export function isWaitlistOnly(value?: string): boolean {
  return value?.trim().toLowerCase() === "true";
}
